// Keep the following in sync with packages/rum-recorder/src/index.ts
export { datadogRum } from './boot/rum.entry';
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@datadog/browser-rum/esm/index.js
// module id = An4P
// module chunks = 24